export default "__VITE_ASSET__YO78c2wr__"